import styled from 'styled-components'
import { mapBreakpoints } from 'etymos'

const getProperty = ({ margin }, variant) => (margin ? `margin-${variant}` : `padding-${variant}`)
const getUnit = value => (typeof value === 'string' ? '' : 'rem')

const H = styled.div`
	${p => p.size && `${getProperty(p, 'left')}: ${p.size}${getUnit(p.size)};`}
	${mapBreakpoints((value, p) => `${getProperty(p, 'left')}: ${value}${getUnit(value)};`)}
`

const V = styled.div`
	${p => p.size && `${getProperty(p, 'top')}: ${p.size}${getUnit(p.size)};`}
	${mapBreakpoints((value, p) => `${getProperty(p, 'top')}: ${value}${getUnit(value)};`)}
`

const Spacer = { V, H }

export default Spacer
